import { StatePreV19, StateV19 } from './19_migrate_produktId.interface';

export const migrateProduktId = (previousState: StatePreV19, version: number): StateV19 => {
  return {
    ...previousState,
    version,
    produkte: previousState.produkte.map(product => {
      const updatedProduct = {
        ...product,
        appId: product.produktId,
      };
      delete updatedProduct.produktId;
      return updatedProduct;
    }),
  };
};
